export class ParamsBuildHelper {
  public static buildGetParams(params: { [name: string ]: string }): string {
    const getParts = [];

    for (const name in params) {
      if (!params.hasOwnProperty(name)) {
        continue;
      }
      if (params[name] !== undefined) {
        getParts.push(`${name}=${encodeURIComponent(params[name])}`);
      }
    }

    return getParts.length > 0
      ? '?' + getParts.join('&').replace(/\+/gi, '%2B')
      : '';
  }
}
